import { toApiDate } from "../../utils/dateUtils";
export var transformFormToApiParams = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return {
        registrationAgency: data.registrationAgency,
        periodFrom: toApiDate(data.periodFrom),
        periodTo: toApiDate(data.periodTo),
        gdprConsent: data.gdprConsent,
        pricing: {
            chargeForIsbn: data.chargeForIsbn,
            pricePerIsbn: (_a = data.pricePerIsbn) !== null && _a !== void 0 ? _a : undefined,
            priceFor10: (_b = data.priceFor10) !== null && _b !== void 0 ? _b : undefined,
            priceFor100: (_c = data.priceFor100) !== null && _c !== void 0 ? _c : undefined,
            priceFor1000: (_d = data.priceFor1000) !== null && _d !== void 0 ? _d : undefined,
            annualMembership: (_e = data.annualMembership) !== null && _e !== void 0 ? _e : undefined,
            registrationFee: (_f = data.registrationFee) !== null && _f !== void 0 ? _f : undefined,
        },
        contact: {
            contactPerson: (_g = data.contactPerson) !== null && _g !== void 0 ? _g : undefined,
            address: {
                organization: (_h = data.organization) !== null && _h !== void 0 ? _h : undefined,
                department: (_j = data.department) !== null && _j !== void 0 ? _j : undefined,
                street: (_k = data.street) !== null && _k !== void 0 ? _k : undefined,
                city: (_l = data.city) !== null && _l !== void 0 ? _l : undefined,
                country: (_m = data.country) !== null && _m !== void 0 ? _m : undefined,
            },
            telephone1: (_o = data.telephone1) !== null && _o !== void 0 ? _o : undefined,
            telephone2: (_p = data.telephone2) !== null && _p !== void 0 ? _p : undefined,
            telephone3: (_q = data.telephone3) !== null && _q !== void 0 ? _q : undefined,
            fax: (_r = data.fax) !== null && _r !== void 0 ? _r : undefined,
            email1: (_s = data.email1) !== null && _s !== void 0 ? _s : undefined,
            email2: (_t = data.email2) !== null && _t !== void 0 ? _t : undefined,
            email3: (_u = data.email3) !== null && _u !== void 0 ? _u : undefined,
            url: (_v = data.url) !== null && _v !== void 0 ? _v : undefined,
        },
    };
};
